import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

/**
 * Array Length Step
 *
 * Outputs the number of items in an input array as a scalar `length`.
 *
 * Use it to gate a Decision node on "did we get any items?" without wiring the
 * array itself into a single-value socket — feeding an array into a
 * single-value socket triggers fanout (one child workflow per item). The input
 * here is an array-typed socket (array → array, no fanout) and the output is a
 * plain number safe to feed a Decision's `value` (`greater_than 0`).
 */
export const arrayLengthStep = defineStepConfig({
  type: "array_length",
  name: "Array Length",
  description:
    "Outputs the number of items in an input array. Gate a Decision on count without triggering array fanout.",
  category: "Utility",

  inputSchema: z.object({
    array: z
      .array(z.unknown())
      .optional()
      .describe("The array to measure. Wire an array output into this socket."),
  }),

  outputSchema: z.object({
    length: z.number().describe("Number of items in the input array"),
  }),

  configSchema: z.object({}),

  emits: [] as const,
});
